export const HomePageDO = {
    id: "",
    descricao_pt: "",
    descricao_en: "",
    modificado_em: ""
}

export const BibliopraphyDO = {
    id: "",
    descricao:"",
    modificado_em: ""
}

export const TeamDO = {
    id:"",
    nome:"",
    cargo:"",
    modificado_em:""
}

export const ContactsDO = {
    id:"",
    nome:"",
    email:"",
    modificado_em:""
}

export const OverviewDO = {
    id:"",
    descricao_pt:"",
    descricao_en:"",
    filmes:"",
    outros_links:"",
    modificado_em:""
}

export const MaterialsDO = {
    id:"",
    descricao_pt:"",
    descricao_en:"",
    filmes:"",
    outros_links:"",
    modificado_em:""
}

export const IconicDO = {
    id:"",
    descricao_pt:"",
    descricao_en:"",
    filmes:"",
    outros_links:"",
}

export const ObraDO = {
    id:"",
    nome:"",
    data_projeto:"",
    tipologia:"",
    localizacao:"",
    descricao_pt:"",
    descricao_en:"",
    fontes_bibliografia:""
}